module.exports = __webpack_public_path__ + "static/media/首页组简体.e0cf79f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/pc/vedio/首页组简体.webm
// module id = TN7k
// module chunks = 13